import { parseAbi } from 'viem';

/** Experimental wire interface only. No runtime/profile approval, order admission,
 * signing permission or compatibility with the single-market record codecs. */
export const experimentalMultiMarketVersion = 'conditional-multimarket.2' as const;
export const experimentalMultiMarketModuleId = 'test-only.conditional-multimarket.2' as const;

export const experimentalMultiMarketAbi = parseAbi([
 'struct RegistrationContext { uint256 globalEpoch; uint256 marketRevision; }',
 'struct MarketProfile { address curve; address base; address quote; bytes32 curveCodeHash; bytes32 policyHash; address canonicalRouter; bytes32 routerCodeHash; address canonicalManager; bytes32 managerCodeHash; bytes32 adapterCodeHash; int24 canonicalTickSpacing; }',
 'struct TriggerTerms { uint256 threshold; bool atOrBelow; bool latchAfterFirstFill; }',
 'struct LegTerms { uint128 minimumTotalOutput; uint16 maximumFeeBps; uint256 expiry; TriggerTerms trigger; }',
 'struct Order { uint256 globalEpoch; bytes32 marketId; uint256 marketRevision; address owner; bool buy; uint128 maximumInput; uint128 minimumTotalOutput; uint16 maximumFeeBps; uint256 expiry; bool cancelled; bool filled; uint128 cumulativeInput; uint256 cumulativeOutput; uint256 fillRevision; }',
 'function vault() view returns(address)',
 'function keeper() view returns(address)',
 'function globalEpoch() view returns(uint256)',
 'function epoch() view returns(uint256)',
 'function armed() view returns(bool)',
 'function healthy() view returns(bool)',
 'function nextOrder() view returns(uint256)',
 'function moduleId() pure returns(string)',
 'function authoritySelectors() pure returns(bytes4[6])',
 'function armInitialSetup()',
 'function arm()',
 'function configureMarket(MarketProfile input) returns(bytes32 marketId)',
 'function disableMarket(bytes32 marketId)',
 'function marketStates(bytes32 marketId) view returns(uint256 revision,bool enabled)',
 'function marketProfile(bytes32 marketId,uint256 revision) view returns(MarketProfile)',
 'function order(uint256 id) view returns(Order)',
 'function triggers(uint256 orderId) view returns(uint256 threshold,bool atOrBelow,bool latchAfterFirstFill)',
 'function allocationPeer(uint256 orderId) view returns(uint256 peerOrderId)',
 'function allocationRemaining(uint256 id) view returns(uint128)',
 'function register(bytes32 marketId,RegistrationContext expected,bool buy,uint128 maximumInput,uint128 minimumTotalOutput,uint16 maximumFeeBps,uint256 expiry,TriggerTerms trigger) returns(uint256 id)',
 'function registerAllocation(bytes32 marketId,RegistrationContext expected,uint128 maximumInput,LegTerms first,LegTerms second) returns(uint256 firstId,uint256 secondId)',
 'function cancel(uint256 id)',
 'function fill(uint256 id,uint128 maximumThisFill,uint256 expectedRevision)',
 'function callsFor(uint256 id,uint128 maximumThisFill) view returns(bytes)',
 'function currentTriggerValuation(bytes32 marketId) view returns(uint256)',
 'function checkCurveTrigger(uint256 id,uint256 revision) view',
 'function checkCanonicalTrigger(address payer,bytes32 poolId,uint256 id,uint256 revision) view returns(bytes4)',
 'event MarketConfigured(bytes32 indexed marketId,uint256 indexed revision)',
 'event MarketDisabled(bytes32 indexed marketId,uint256 indexed revision)',
 'event Registered(uint256 indexed id,bytes32 indexed marketId,uint256 marketRevision,uint256 globalEpoch,bool buy,uint128 input,uint128 minimumOutput)',
 'event Cancelled(uint256 indexed id)',
 'event Filled(uint256 indexed id,uint256 revision,uint256 actualInput,uint256 actualOutput,uint256 cumulativeInput,uint256 cumulativeOutput,bool complete)',
 'error Denied()',
 'error Unhealthy()',
 'error InvalidMarket()',
 'error InvalidOrder()',
 'error TriggerNotMet()',
 'error BalanceBound()',
]);
